import IndustryActivity from "../../searchFlowVersionB/components/industryActivity/IndustryActivity.jsx";
import i18n from "../../../utils/i18n";

export {
  INDUSTRIES_WITH_ACTIVITY_CONTENT as VAF_INDUSTRIES_WITH_ACTIVITY_CONTENT,
  industryHasActivityContent as vafIndustryHasActivityContent,
  isIndustryActivityAnswered as isVafIndustryActivityAnswered,
} from "../../searchFlowVersionB/utils/industryActivity.js";

const VafIndustryActivity = () => (
  <IndustryActivity title={i18n.t("searchflow.regactivitytitle")} />
);

export default VafIndustryActivity;
